<template>
  <section class='page-medicalTreatment'>
    <resolution :current="medicalTreatment"/>
  </section>
</template>

<script>
import resolution from './index.vue'
import { CONSOLE_SITE_URL } from '@/utils/constants';
export default {
  metaInfo: {
  title: '医学会议解决方案_医学会议直播_马兰头医学科技',
  meta: [
    {
      name: 'keywords',
      content: '医学会议解决方案，手术示教，医学会议直播，线上医学会议，医学学术会议'
    },
    {
      name: 'description',
      content: '通过以音视频互动为核心的马兰头音视频PaaS平台，提供专业的医学学术会议直播互动平台'
    },
  ]
  },
  name: 'medicalTreatment',
  components: {
    resolution
  },
  data () {
    return {
      medicalTreatment: {
        whyChoose: true,
        banner: {
          title: '医学直播平台',
          desc: '专业的医学学术会议直播互动平台',
          image: require('@/assets/resolution/medicalTreatment/banner_img.png'),
          buttonText: '立即体验',
          buttonCallback: () => {
            window.open(CONSOLE_SITE_URL);
          }
        },
        use: {
          title: '使用场景',
          subtitle: '六大特色，共同打造一场专业级线上医学学术会议',
          content: [{
            title: '线上直播互动',
            subtitle: '最高支持36路视频同时接入，支持专家/嘉宾互动加入、观众文字提问',
            img: require('@/assets/resolution/medicalTreatment/case1.png')
          }, {
            title: '专属学分通道',
            subtitle: '支持学分通道登陆观看，自助积累学分',
            img: require('@/assets/resolution/medicalTreatment/case2.png')
          }, {
            title: '最高4K清晰度直播',
            subtitle: '马兰头多方融合视频引擎、音视频质量达到业界领先水平。支持1080P，60帧高清音画直播',
            img: require('@/assets/resolution/medicalTreatment/case3.png')
          }, {
            title: '会议录播',
            subtitle: '支持会议录播，沉淀会议培训课程、资料，支持点播教学。学者可随时登录观看，更可统计学习时长',
            img: require('@/assets/resolution/medicalTreatment/case4.png')
          }, {
            title: '会议服务管家',
            subtitle: '会议助理功能，可操控演讲人权限和顺序，保证会议流程顺畅。技术护航，线上调控，现场执行一站式直播服务',
            img: require('@/assets/resolution/medicalTreatment/case5.png')
          }, {
            title: '“广播级”手术直播',
            subtitle: '音视频同步直播，4K高清画质。保留精彩学术内容。弥补了手术空间局限，观摩人数有限，观看视野预期等传统模式的不足',
            img: require('@/assets/resolution/medicalTreatment/case6.png')
          }]
        },
        features: {
          isGrey: true,
          title: '特色功能点',
          content: [
            {
              img: require('@/assets/resolution/features/icon_1.png'),
              text: '直播互动'
            }, {
              img: require('@/assets/resolution/features/icon_2.png'),
              text: '点播教学'
            }, {
              img: require('@/assets/resolution/features/icon_3.png'),
              text: '桌面共享'
            }, {
              img: require('@/assets/resolution/features/icon_4.png'),
              text: '全终端支持'
            }, {
              img: require('@/assets/resolution/features/icon_5.png'),
              text: '点播教学'
            }, {
              img: require('@/assets/resolution/features/icon_6.png'),
              text: '品牌定制化'
            }
          ]
        },
        demonstration: {
          isGrey: true,
          showList: true,
          companyList: [1,9,8,6]
        }
      }
    }
  },
}
</script>

<style lang='less'>
.page-medicalTreatment {}
</style>
